<template>
    <div>
        <b-table borderless :fields="bootstrapTable.fields" :items="data">
            <template v-slot:cell(id)="data">
                <router-link class="text-data-link" :to="'/hms/signatures/' + data.item.links.self"
                             v-text="data.item.data.attributes.code"/>
            </template>

            <template v-slot:cell(date)="data">
                <span v-text="data.item.data.attributes.date"/>
            </template>

            <template v-slot:cell(facility)="data">
                <span v-text="data.item.data.attributes.facility"/>
            </template>

            <template v-slot:cell(occupied_units)="data">
                <span v-text="data.item.data.attributes.occupied_units"/>
            </template>

            <template v-slot:cell(total_signed)="data">
                <span v-text="data.item.data.attributes.total_signed"/>
            </template>

            <template v-slot:cell(sign_percentage)="data">
                <span v-text="data.item.data.attributes.sign_percentage"/>
            </template>

            <template v-slot:cell(updated_by)="data">
                <span v-text="data.item.data.attributes.updated_by"/>
            </template>

            <template v-slot:cell(updated_at)="data">
                <span v-text="data.item.data.attributes.updated_at"/>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        name: "LatestSignatures",
        props: ['data'],
        data() {
            return {
                bootstrapTable: {
                    fields: [
                        {key: 'id', label: 'Code', tdClass: ''},
                        {key: 'date', label: 'Date', tdClass: 'text-muted'},
                        {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                        {key: 'occupied_units', label: 'Occupied Units', tdClass: 'text-muted'},
                        {key: 'total_signed', label: 'Total Signed', tdClass: 'text-muted'},
                        {key: 'sign_percentage', label: 'Sign Percentage', tdClass: 'text-muted'},
                        {key: 'updated_by', label: 'Updated By', tdClass: 'text-muted'},
                        {key: 'updated_at', label: 'Updated At', tdClass: 'text-muted'},
                    ]
                }
            }
        },
    }
</script>

<style scoped>

</style>
